import React from "react";
import AuthManager from "../../../Common/AuthManager";

function UserIndex() {
  return (
    <div className="container-fluid" data-testid="user-profile-page">
      <h2>Profile</h2>
      <hr />
      <div className="row">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button data-testid="profile-index-button-1"
              className="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#Download"
              type="button"
              role="tab"
              aria-controls="Download"
              aria-selected="true"
            >
              <strong>Profile</strong>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button data-testid="profile-index-button-2"
              className="nav-link"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#upload"
              type="button"
              role="tab"
              aria-controls="upload"
              aria-selected="false"
            >
              <strong>json</strong>
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane fade show active"
            id="Download"
            role="tabpanel"
            aria-labelledby="home-tab"
          ></div>
          <div
            className="tab-pane fade"
            id="upload"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div>
              <pre>{JSON.stringify(AuthManager.getAuthUser(), null, 2)}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserIndex;
